import { render, staticRenderFns } from "./containerBox.vue?vue&type=template&id=180b8390&scoped=true&"
import script from "./containerBox.vue?vue&type=script&lang=js&"
export * from "./containerBox.vue?vue&type=script&lang=js&"
import style0 from "./containerBox.vue?vue&type=style&index=0&id=180b8390&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b8390",
  null
  
)

export default component.exports